import { connect } from "react-redux";
import * as React from "react";
import Main from "../Root/Main";
import Header from "./Header";
import Sidebar from './Sidebar';
import { Theme } from '@mui/material/styles';
import { WithStyles, withStyles } from '@mui/styles';
import { createStyles } from '@mui/styles';
import { Grid2 as Grid, Button, CssBaseline, Typography, Box } from '@mui/material';
import Footer from '../Footer/Footer';
import { RouteComponentProps, withRouter } from "react-router";
import idssStyle from "../../Configuration/SharedStyling";
import RootState from "../../State/Root/RootState";
import logo from '../../Images/logo@2x.png';
import * as AuthorizationPolicies from "../../Configuration/AuthorizationPolicies";
import { User } from "oidc-client";
import { ISubmissionAllowance } from "../../DataClasses/SubmissionData";
import { IMenuActionAllowance } from "../../DataClasses/ActionAllowanceData";
import { AjaxError } from "rxjs/ajax";
import SubmissionsService from "../Services/SubmissionsService";
import UserManagerService from "../Services/UserManagerService";
import { Link, LinkProps } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { IAdministrationPayload } from "../../DataClasses/AdministrationData";
import AdministrationService from '../Services/AdministrationService';

//import LoginButton from "../Authentication/LoginButton";
import classNames from 'classnames'
import { firstValueFrom } from "rxjs";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import froalaBaseConfig from "../../Utilities/BaseFroalaConfig";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

// REDUX PROPS

interface IAppWithAuthProps {
    user: User | null,
    isNcqaAdmin: boolean;
    isUserAdmin: boolean;
}


interface IAppWithAuthState {
    isSidebarOpened: boolean
    uploadavailabilities: ISubmissionAllowance,
    menuItemAvailabilities: IMenuActionAllowance,
    redirect: boolean,
    isIE: boolean;
    adminConfigOptions: IAdministrationPayload;
    userMsgOnLoginModel: { enable: boolean, message: string };
}

const mapStateToProps = (state: RootState): IAppWithAuthProps => {
    return ({
        user: state.AuthenticationReducer.user,
        isNcqaAdmin: AuthorizationPolicies.IsGlobalAdmin(state.AuthenticationReducer.user),
        isUserAdmin: AuthorizationPolicies.IsOrgAdmin(state.AuthenticationReducer.user),
    });
};

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
    (props, ref) => <Link innerRef={ref as any} {...props} />
);

type IStylesProps = WithStyles<typeof styles>;


// VIEW
class AppWithAuthentication extends React.Component<IStylesProps & IAppWithAuthProps, IAppWithAuthState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isSidebarOpened: true,
            uploadavailabilities:
            {
                allowsHedisSubmission: false,
                allowsCahpsSubmission: false,
                allowsHosSubmission: false,
                allowsQrsSubmission: false,
                allowsDqsSubmission: false,
            },
            menuItemAvailabilities:
            {
                allowsBulkMarkFinalCahps: false,
                allowsBulkMarkFinalHos: false,
                allowsBulkAttestationHos: false,
                allowsUserManagement: false,
                allowsBulkDownloadHedis: false,
                allowsBulkDownloadHos: false,
                allowsBulkDownloadCahps: false,
                allowsHistoricalFiles: false
            },
            redirect: false,
            isIE: false,
            adminConfigOptions: {
                allowsHosSubmission: false,
                allowsCahpsSubmission: false,
                allowsHedisSubmission: false,
                allowsQrsSubmission: false,
                allowsDqsSubmission: false,
                enableMeasureGuidValidation: false,
                enableExperimentalValidation: false,
                isOffseasonMode: false,
                isMaintenanceMode: false,
                licenseAgreementText: '',
                enableGenericUpload: false,
                measurementYear: -1,
                enableHosInterimDataSubmission: false,
                measureModelDate: '',
                isDcapEnvironment: false
            },
            userMsgOnLoginModel: { enable: false, message: "" }
        };
    }

    public componentDidMount() {
        const isEdge = window.navigator.userAgent.indexOf('Edge') !== -1;
        const isIE = window.navigator.userAgent.indexOf('Trident') !== -1 && !isEdge;
        if (isIE) {
            this.setState({ isIE: true });
        }
        else {
            this.RefreshModel();
        }
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    public render() {
        const { classes } = this.props;

        if (this.state.isIE) {
            return (
                <Grid container={true} className={classes.loginGrid}>
                    <Grid>
                        <Box mb={2}>
                            <img src={logo} alt="IDSS logo" />
                        </Box>
                    </Grid>
                    <Grid className={classes.browserSupport}>
                        <h3>Internet Explorer is not supported. Please use some other browser to access IDSS website.</h3>
                    </Grid>
                </Grid>
            );
        }
        else {
            if (this.state.redirect) {
                return this.redirectToErrorPage();
            }
            if (this.props.user)
                return (
                    <div>
                        <CssBaseline />
                        <Sidebar {...this.props} menuItemAvailabilities={this.state.menuItemAvailabilities} uploadavailabilities={this.state.uploadavailabilities}
                            toggleSidebarAction={() => this.toggleSidebarOpen()} adminConfigOptions={this.state.adminConfigOptions} />
                        <div className={(classNames(classes.content, {
                            [classes.contentShift]: this.state.isSidebarOpened
                        }))}>
                            <Header />
                            <Main />
                            <Footer />
                        </div>
                    </div>
                )
            else
                return (
                    <div className={classes.loginGrid}>
                        <div style={{ textAlign: 'center' }}>
                            <Box mb={1}>
                                <img src={logo} alt="IDSS logo" />
                            </Box>
                            <Box mb={1}>
                                <Typography variant="h4" gutterBottom>
                                    Welcome to IDSS
                                </Typography>
                            </Box>
                            <Box>
                                <Button to={"/login"} variant='contained' color="primary" component={AdapterLink}>
                                    Login
                                </Button>
                            </Box>
                        </div>
                        {this.state.userMsgOnLoginModel.enable === true && (
                            <div>
                                <Box mt={2}>
                                    <FroalaEditorView
                                        model={this.state.userMsgOnLoginModel.message}
                                        config={{ ...froalaBaseConfig }}
                                    />
                                </Box>
                            </div>
                        )}
                    </div>
                );
        }
    }

    toggleSidebarOpen = () => {
        this.setState({
            isSidebarOpened: !this.state.isSidebarOpened
        });
    }

    private async RefreshModel() {
        if (this.props.user) {
            //bulk upload
            const retval = await firstValueFrom(SubmissionsService.GetUploadAvailabilities$(this.props.user));
            if (retval instanceof AjaxError || !retval) {
                this.setRedirectState();
            }
            else {
                this.setState({ uploadavailabilities: retval })
            }
            //
            const itemAv = await firstValueFrom(UserManagerService.GetMenuItemAvailabilities$(this.props.user));
            if (itemAv instanceof AjaxError || !itemAv) {
                this.setRedirectState();
            }
            else {
                this.setState({ menuItemAvailabilities: itemAv })
            }

            //get admin config options
            const adminRetval = await firstValueFrom(AdministrationService.GetAdminModel(this.props.user));
            if (adminRetval instanceof AjaxError || !adminRetval) {
                this.setRedirectState();
            } else {
                this.setState({ adminConfigOptions: adminRetval });
            }
        }

        //get User Message
        const userMsg$ = AdministrationService.GetConfigUserMsgOnLoginModel$();
        let userMsg = await firstValueFrom(userMsg$);
        if (!(userMsg instanceof AjaxError || !userMsg)) {
            this.setState({ userMsgOnLoginModel: userMsg })
        }
    }


}
const AppWithAuthenticationPropState = withRouter(connect<IAppWithAuthProps, {}, RouteComponentProps<{}>>(mapStateToProps)(AppWithAuthentication));

// STYLES CONTAINER
const AppWithAuthenticationState = withStyles(styles)(AppWithAuthenticationPropState);

// REDUX CONTAINER
export default AppWithAuthenticationState;

